module.exports = __webpack_public_path__ + "img/cr1.0b21b583.png";